import { Container, Grid, Stack, Toolbar, Typography } from "@mui/material";

export default function Expo2013Content() {
    return (
        <>
            <Toolbar />

            <Typography variant="h4" sx={{ color: '#EF3E00', textAlign: 'center' }}>Indian Pharma Expo 2013</Typography>

            <Toolbar />
            <Container>
                <Grid container spacing={16}>
                    <Grid item xs={12} sm={12} md={8} lg={8}>
                        <Typography sx={{ lineHeight: '2' }} className="d-flex align-self-center">
                            The Indian Pharma Expo 2013 took place on 20- 21 sept at Pragati Maidan in New Delhi. It was a unique pharma event, which proved to be the perfect platform flooded with opportunities for pharma entrepreneurs such as Pharmaceutical Manufacturers & Ethical, PCD and Generic companies, eager to explore distributorship, franchisee & Third Party Manufacturing for their brands. Many Pharma students, doctors and consultants also visited the Exhibition and gained good exposure of Indian Pharma Industry.
                            <br /><br />
                            It was a great pleasure to participate in such a good pharma event. UBM Medica, the organizers of Indian Pharma Expo, made appreciable efforts to bring so many pharmaceutical companies and related visitors from all around the nation together at a single place and provide platform for everybody to Explore opportunities for themselves in Pharma Industry.
                            <br /><br />
                            This event provided great opportunity to all the exhibitors to market their products to pharmaceutical industry, increase awareness about their products and improve their corporate visibility.
                            <br /><br />
                            We want to thank our dedicated Staff, our associated companies who played major role in all arrangements and visitors for making Indian Pharma Expo-2012 a success for us.
                            We would again like to thank the Team of UBM medica who worked so hard to keep the arrangements good for all of us to enjoy this event and take maximum benefit out of it.
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <Stack spacing={2}
                            alignItems="start"
                            justifyContent={"start"}
                            sx={{ width: '100%', height: '100%' }}
                        >
                            <Typography variant="h6" sx={{ color: '#EF3E00', textAlign: 'start' }}>Exhibition Highlights</Typography>
                            <Typography variant="body1">
                                <li> B2B (Business-to-business) Exhibition </li>
                            </Typography>
                            <Typography variant="body1">
                                <li>Pharmaceuticals Products Exhibition</li>
                            </Typography>
                            <Typography variant="body1">
                                <li>Perfect platform for All Contract  &  API manufacturers.</li>
                            </Typography>
                        </Stack>
                    </Grid>
                </Grid>

                <Toolbar />

            </Container>
        </>
    )
}